import { render, staticRenderFns } from "./receipt-page-head-preloader.vue?vue&type=template&id=16cb0507&scoped=true"
import script from "./receipt-page-head-preloader.vue?vue&type=script&lang=ts"
export * from "./receipt-page-head-preloader.vue?vue&type=script&lang=ts"
import style0 from "./receipt-page-head-preloader.vue?vue&type=style&index=0&id=16cb0507&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cb0507",
  null
  
)

export default component.exports